import React, { Dispatch, useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import CardMobile from './components/CardMobile';
import Spin from '../../../../components/Spin';
import Refresh from '../../../../components/Refresh';
import { getCentrosDistribuicao } from './services';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { useWindowSize } from '../../../../hook/useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { loadRequest } from '../../../../store/ducks/consultaAgendamentos/actions';
import { Action } from 'typesafe-actions';
import mask from '../../../../utils/mask';
import { Container, Titulo, ContainerGrid, CardInfo, Aviso, CardContainer } from './styles';
import iconcoleta from '../../../../assets/img/coleta.svg';
import iconentrega from '../../../../assets/img/entrega.svg';

import { InfosHeader } from './components/Info';
import { ModalDetalhesAgendamento } from './components/ModalDetalhesAgendamento';
import type { PropsRef } from './components/ModalDetalhesAgendamento';

const CalendarBox: React.FC = () => {
  const refVisibleModalDetalhesAgendamento = useRef<PropsRef>(null);
  const { width }: any = useWindowSize();
  const dispatch = useDispatch<Dispatch<Action>>();
  const localizer = momentLocalizer(moment);

  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const consultaAgendamentos = useSelector((state: ApplicationState) => state.ConsultaAgendamentos.data);
  const loadingRequest = useSelector((state: ApplicationState) => state.ConsultaAgendamentos.loading);
  const codCdd = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd);
  const filter = useSelector((state: ApplicationState) => state.ConsultaAgendamentos.filter);

  const [stateAgendado, setStateAgendado] = useState<boolean>(true);
  const [stateFinalizado, setStateFinalizado] = useState<boolean>(true);
  const [stateEntrega, setStateEntrega] = useState<boolean>(true);
  const [stateColeta, setStateColeta] = useState<boolean>(true);
  const [codAgendamento, setCodAgendamento] = useState<number | undefined>(undefined);

  const messages = {
    allDay: 'Dia Inteiro',
    previous: '<',
    next: '>',
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
  };

  let formats = {
    dayHeaderFormat: 'dddd, DD MMMM',
  };

  const handleStateSwitch = (
    newStateAgendado: boolean,
    newStateFinalizado: boolean,
    nwStateEntrega: boolean,
    newStateColeta: boolean
  ) => {
    setStateAgendado(newStateAgendado);
    setStateFinalizado(newStateFinalizado);
    setStateEntrega(nwStateEntrega);
    setStateColeta(newStateColeta);
  };

  const [horarios, setHorarios] = useState<{ start: string; end: string }>({
    start: '07:00',
    end: '18:00',
  });

  useEffect(() => {
    getCentrosDistribuicao.getCentrosDistribuicao(Number(codCdd)).then((res) => {
      const start = res.data.centrosDistribuicao[0]?.hrInicioAgendamento;
      const end = res.data.centrosDistribuicao[0]?.hrFimAgendamento;
      if (!start || !end || start?.includes('#') || end?.includes('#')) {
        setHorarios({
          start: '07:00',
          end: '18:00',
        });
        return;
      }
      setHorarios({
        start,
        end,
      });
    });
  }, [codCdd]);

  useEffect(() => {
    dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd));
  }, [inscricaoAtiva, cddAtivo, filter, dispatch]);

  const group_to_plataforma = consultaAgendamentos.reduce(function (obj: any, item) {
    obj[item.plataforma] = obj[item.plataforma] || [];
    obj[item.plataforma].push({
      codVeiculo: item?.codVeiculo,
      placa: item?.placa,
      centroDistribuicao: item?.centroDistribuicao,
      cliente: item?.cliente,
      codAgendamento: item?.codAgendamento,
      codCentroDistribuicao: item?.codCentroDistribuicao,
      codCliente: item?.codCliente,
      codHorario: item?.codHorario,
      codMotorista: item?.codMotorista,
      codOrdemCarga: item?.ordemCarga,
      codPlataforma: item?.codPlataforma,
      plataforma: item?.plataforma,
      codTransportadora: item?.codTransportadora,
      cpfMotorista: item?.cpfMotorista,
      dhAgendamento: item?.dhAgendamento,
      fimPrevisto: item?.fimPrevisto,
      motorista: item?.motorista,
      pesoBruto: item?.pesoBruto,
      status: item?.status,
      transportadora: item?.transportadora,
      valor: item?.valor,
      tipoWms: item?.tipoWms,
      dhChegada: item?.dhChegada,
      dhEntrada: item?.dhEntrada,
      dhSaida: item?.dhSaida,
      listaNf: item?.listaNf,
    });
    return obj;
  }, {});

  const docas = Object.keys(group_to_plataforma).map(function (key) {
    return {
      plataforma: key,
      agendamentos: group_to_plataforma[key],
    };
  });

  const dateConverter = (item: string = '') => {
    const date = item.split(' ')[0];
    const hour = item.split(' ')[1];
    const dateFormat = date.split('/');
    return new Date(`${dateFormat[1]}-${dateFormat[0]}-${dateFormat[2]} ${hour}`);
  };

  const customEvent = ({ event }: any) => {
    return (
      <Tooltip
        title={
          <div>
            <h4 style={{ color: '#EEE' }}>Lista de NF-e: </h4>

            <ul style={{ padding: 0, listStyle: 'none' }}>
              {event?.listaNf?.map((item: any, index: number) => {
                return (
                  <li key={index}>
                    <span style={{ color: '#EEE' }}>{item}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        }
      >
        <CardContainer>

          <div className='iconCard'>
            {event.tipoWms === 'EXP' ? (
              <img src={iconcoleta} alt="Coleta" title="Coleta" />
            ) : (
              <img src={iconentrega} alt="Entrega" title="Entrega" />
            )}
          </div>

          <div>
            <small>Agendamento </small>
            <CardInfo $status={event.status}>
              {event.code}
            </CardInfo>
          </div>

          <div >
            <small>Veículo </small>
            <CardInfo $status={event.status}>
              {event.placa?.toUpperCase()}
            </CardInfo>
          </div>

          <div className='cliente'>
            <small>Cliente </small>
            <CardInfo $status={event.status}>
              {mask('camelCase', event.cliente)}
            </CardInfo>
          </div>

          <div className='trans'>
            <small>Transportadora </small>
            <CardInfo $status={event.status}>
              {mask('camelCase', event.transportadora)}
            </CardInfo>
          </div>


        </CardContainer>
      </Tooltip>
    );
  };

  const calendarStyle = () => {
    return {
      style: {
        backgroundColor: '#fff',
      },
    };
  };

  return (
    <Container className="contConsultaAgendamento">
      <Refresh
        loadRequest={() => dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd))}
      />

      <InfosHeader handleStateSwitch={handleStateSwitch} />
      <ModalDetalhesAgendamento
        ref={refVisibleModalDetalhesAgendamento}
        detalhesAgendamento={
          consultaAgendamentos.filter((item) => item.codAgendamento === codAgendamento)[0] as any
        }
      />
      {loadingRequest ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin color="#1890FF" />
        </div>
      ) : (
        width > 768 && (
          <ContainerGrid className="grade">
            {docas?.map((item: any, index) => {
              return (
                <div style={{ minWidth: '200px', width: '100%' }} key={item.plataforma}>
                  <div style={{ display: 'flex' }}>
                    <Titulo>
                      {item?.plataforma.split(' ')[0]}
                      <div>{('00' + item.plataforma.split(' ')[1]).slice(-2)}</div>
                    </Titulo>
                  </div>
                  <Calendar
                    events={item?.agendamentos?.map((item: any) => ({
                      id: item.codAgendamento,
                      transportadora: item.transportadora,
                      placa: item.placa,
                      cliente: item.cliente,
                      code: item.codAgendamento,
                      start: dateConverter(item.dhAgendamento),
                      end: dateConverter(item.fimPrevisto),
                      status: item.status,
                      tipoWms: item.tipoWms,
                      codCentroDistribuicao: item.centroDistribuicao,
                      dhChegada: item.dhChegada,
                      dhEntrada: item.dhEntrada,
                      dhSaida: item.dhSaida,
                      listaNf: item.listaNf,
                      codOrdemCarga: item.ordemCarga,
                      resourceId: 1,
                      plataforma: item.plataforma,
                    }))}
                    eventPropGetter={(event: any) => {
                      let bordercolor = '';
                      let backgroud = '';
                      let color = '';
                      let stateAgendamento = true;
                      switch (event.status) {
                        case 'AGE':
                          backgroud = '#F5DECC';
                          bordercolor = '#B45309';
                          color = '#813b06';
                          stateAgendamento = stateAgendado;
                          break;
                        case 'EXP':
                          backgroud = '#D7F3FF';
                          bordercolor = '#1890FF';
                          color = '#0d579d';
                          stateAgendamento = stateFinalizado;
                          break;
                        default:
                          backgroud = '#fff';
                          bordercolor = '#e0e0e0';
                          color = '#fff';
                          break;
                      }
                      let stateTipo = true;
                      switch (event.tipoWms) {
                        case 'REC':
                          stateTipo = stateEntrega;
                          break;
                        case 'EXP':
                          stateTipo = stateColeta;
                          break;
                        default:
                          break;
                      }
                      return {
                        style: {
                          display: stateAgendamento && stateTipo ? 'flex' : 'none',
                          backgroundColor: backgroud,
                          borderRadius: '4px',
                          color: color,
                          border: 'none',
                          borderLeft: `3px solid ${bordercolor}`,
                          borderBottom: `2px solid ${bordercolor}`,
                          overflowY: 'scroll',
                        },
                      };
                    }}
                    className={index === 0 ? 'active' : ''}
                    style={{ height: '1200px' }}
                    key={item.plataforma}
                    min={moment(`${horarios.start}am`, 'h:mma').toDate()}
                    max={moment(`${horarios.end}pm`, 'h:mma').toDate()}
                    startAccessor="start"
                    endAccessor="end"
                    defaultView="day"
                    views={['day']}
                    localizer={localizer}
                    selectable={false}
                    defaultDate={new Date()}
                    date={
                      filter?.dtAgendamento
                        ? moment(filter?.dtAgendamento).format()
                        : moment().format()
                    }
                    onSelectEvent={(e) => {
                      setCodAgendamento(e.id);
                      refVisibleModalDetalhesAgendamento?.current?.showModal();
                    }}
                    resourceIdAccessor="resourceId"
                    dayPropGetter={calendarStyle}
                    messages={messages}
                    formats={formats}
                    components={{
                      event: customEvent,
                    }}
                  />
                </div>
              );
            })}
          </ContainerGrid>
        )
      )}

      {width < 768 && <CardMobile consultaAgendamentos={consultaAgendamentos} />}

      {consultaAgendamentos.length < 1 && (
        <Aviso>Não há agendamentos para o dia {moment(filter?.dtAgendamento).format('LL')}</Aviso>
      )}
    </Container>
  );
};

export default CalendarBox;
